<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      StateCust: ["Select"],
      StateCustOne: ["Select"],
      StateCustTwo: ["Select"],
      StateCustThree: ["Select"],
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/success");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <!-- Add Customer -->
  <div class="modal fade custom-modal" id="add-user">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Add Customer</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body p-4">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">First Name</label>
                  <input type="text" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">Last Name</label>
                  <input type="text" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="col-form-label">Email</label>
                  <input type="email" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="col-form-label">Phone Number</label>
                  <input type="number" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="col-form-label">Address</label>
                  <input type="text" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">Country</label>
                  <vue-select
                    :options="StateCustThree"
                    id="statcustThree"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">State</label>
                  <vue-select :options="StateCust" id="statcust" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">City</label>
                  <vue-select
                    :options="StateCustOne"
                    id="statcustone"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="col-form-label">Zip Code</label>
                  <input type="text" class="form-control pass-input" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="col-form-label">Status</label>
                  <vue-select
                    :options="StateCustTwo"
                    id="statcusttwo"
                    placeholder="Select"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end align-items-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Customer -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
